import { Component, TemplateRef, OnInit } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ConnectionService } from 'src/app/connection.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-governance-bodies',
  templateUrl: './governance-bodies.component.html',
  styleUrls: ['./governance-bodies.component.css']
})
export class GovernanceBodiesComponent implements OnInit {
  submitted: boolean = false
  governanceObj: any = {}
  modalRef?: BsModalRef;
  address: any;
  balance: any;
  disableStatus: any;
  token: string;
  validatorList: any;
  dashboardDetails: any;
  Latestblock: any;
  totalTxns: any;
  totalAccounts: any;
  currentTPS: any;
  totalNodes: any;
  totalFrozen: any;
  searchobj: any = {
    searchAddress: ''
  }
  searchListDetails: any;
  isExists: any;
  constructor(private modalService: BsModalService, private conn: ConnectionService, private alert: ToastrService, private router: Router) {
    this.conn.coinBalance.subscribe((res: any) => {
      this.balance = res
    })
  }

  ngOnInit() {
    this.address = localStorage.getItem('Address')
    this.token = localStorage.getItem('Sastana_Token')
    this.latestBlockDetails()
    this.getValidators()
    setTimeout(() => {
      this.checkBalance()
    }, 1000)

  }

  openModal(template: TemplateRef<any>) {
    setTimeout(() => {
      this.modalRef = this.modalService.show(template);
    }, 2000)
  }

  checkBalance() {
    if ((this.balance >= 10000)) {
      this.disableStatus = false
    }
    else {
      this.disableStatus = true
    }
  }


  latestBlockDetails() {
    this.conn.postUrl('users/dashboard-data', {}).subscribe((res: any) => {
      this.dashboardDetails = res.data
      this.Latestblock = this.dashboardDetails.latestBlocks
      this.totalTxns = this.dashboardDetails.totalTxns
      this.totalAccounts = this.dashboardDetails.totalAccounts
      this.currentTPS = this.dashboardDetails.currentTPS
      this.totalNodes = this.dashboardDetails.totalNodes
      this.totalFrozen = this.dashboardDetails.totalFrozen

    })
  }

  getValidators() {
    this.conn.getUrl('superRep/getAllWitness').subscribe((res: any) => {
      this.validatorList = res.data;
    });
  }

  createWitness() {
    var checkWitness = this.validatorList.find(e => e.address === this.address)
    if (checkWitness) {
      this.isExists = checkWitness.address
      if (this.isExists == this.address) {
        this.alert.error('Witness already exists');
      }
      else {
        this.conn.postUrl('users/createwitness', { address: this.address, url: this.governanceObj.url }).subscribe((res: any) => {
          if (res.success == true) {
            this.alert.success(res.msg);
            window.location.reload()
          }
          else {
            this.alert.error(res.msg);
          }
        })
      }

    }
  }

  searchDetails(type: any, search: any) {
    if (type == 'address' || type == 'transHash' || type == 'blockNumber') {
      this.router.navigate(['/tag/', type, search])
    }
    else {
      this.router.navigate(['/contract-read/', search])
    }
  }



}
